import {
  calcDateTime,
  getIsWednesday,
  getPreviousWednesday,
  isSameDateTime,
  formatDateTime,
  DateTimeFormat,
} from '@occc-app/lib/date';

import { WEEK_SELECTOR_MAX_WEEKS_COUNT } from './week-selector.constants';

// Returns the most recent Wednesday, including today if today is Wednesday
// Most recent Wednesday relative to the given date (returns the same date if it's Wednesday)
export const getMostRecentWednesday = (fromDate = new Date()): Date => {
  const date = new Date(fromDate);
  return getIsWednesday(date) ? date : getPreviousWednesday(date);
};

export const getMinSelectableWednesday = (): Date => {
  return calcDateTime(getMostRecentWednesday(), 'sub', WEEK_SELECTOR_MAX_WEEKS_COUNT - 1, 'week');
};

export const normalizeToMostRecentWednesday = (date: Date): Date => {
  return getMostRecentWednesday(date);
};

export const buildWeekSelectorButtonLabel = (selectedDate: Date): string => {
  const mostRecentWednesday = getMostRecentWednesday();
  const isMostRecentDay = isSameDateTime(selectedDate, mostRecentWednesday, 'day');
  if (isMostRecentDay) {
    return 'Last Week';
  }
  return `Week of ${formatDateTime(selectedDate, DateTimeFormat.DateWithYear)}`;
};
